export const portfolioData = [
  {
    id: 1,
    name: 'Udruga',
    languages: ['react','php', 'symfony','javascript'],
    languagesIcons: ['fab fa-js','fab fa-php','fab fa-react','fab fa-symfony'],
    source: 'https://github.com/charafcolo/Udruga-back',
    info: 'Udruga (qui signifie “association” en croate) est un site permettant à des associations de gérer et d’organiser des évènements.',
    picture: './media/project1.JPG'
  },
  {
    id: 2,
    name: 'Stat-Covid',
    languages: ['php','symfony', 'bootstrap', 'javascript'],
    languagesIcons: ['fab fa-php','fab fa-symfony', 'fab fa-bootstrap'], 
    source: 'https://github.com/charafcolo/stats-covid',
    info: "Petit projet de consommation d'API sur les chiffres du covid19. Technos : Symfony, Twig, Bootstrap.",
    picture: './media/project2.JPG'
  },
  {
    id: 3,
    name: 'charafcolo.fr',
    languages: ['javascript','react'],
    languagesIcons: ['fab fa-js','fab fa-react'],
    source: 'https://github.com/charafcolo/Charaf-Portfolio',
    info: 'Mon CV en ligne réalisé avec React JS',
    picture: './media/project3.JPG'
  },
  {
    id: 4,
    name: 'renonat.com',
    languages: ['php','javascript'],
    languagesIcons: ['fab fa-php'],
    source: 'https://github.com/charafcolo/',
    info: "Site vitrine pour professionnelle de la maîtrise d'oeuvre.",
    picture: './media/project4.JPG'
  },

]